import {
  ProductTemplateAsViennaProps,
  SizePickerModalProps,
} from "@made-people/blueprint-product";
import { ChevronLeft } from "../../../assets/icons/ChevronLeft";
import { ChevronRight } from "../../../assets/icons/ChevronRight";
import { Cross } from "../../../assets/icons/Cross";
import { MMProductDeliveryStatus } from "../../features/delivery-status/mm-product-delivery-status";
import { SizeGuideTrigger } from "../../features/size-guide";

export const SizePickerModal = {
  template: "modal",
  drawerSettings: {
    header: {
      closeIcon: <Cross className="w-4 h-4" />,
    },
  },
  aboveButtonComponent: <MMProductDeliveryStatus />,
  belowButtonComponent: <SizeGuideTrigger className="mt-2" />,
} satisfies SizePickerModalProps;

export const StickyAddToCartButton = {
  showPrice: false,
};

export const ProductTemplateAsVienna = {
  template: "vienna",
  imageGallerySettings: {
    template: "keen",
    indicator: "dots",
    videoSettings: {
      autoPlay: true,
      muted: true,
      controls: true,
      className: "!object-contain",
    },
    navigation: {
      enabled: {
        mobile: true,
        tablet: true,
        desktop: true,
      },
      prevIcon: <ChevronLeft />,
      nextIcon: <ChevronRight />,
    },
    slidesPerView: {
      mobile: 1,
      tablet: 1.3,
      desktop: 1.5,
    },
    gap: {
      mobile: 0,
      tablet: 0,
      desktop: 0,
    },
  },
} satisfies ProductTemplateAsViennaProps;
